var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraButtonIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66634 2.66666H6.33301L4.66634 4.66666H2.66634C2.31272 4.66666 1.97358 4.80713 1.72353 5.05718C1.47348 5.30723 1.33301 5.64637 1.33301 5.99999V12C1.33301 12.3536 1.47348 12.6928 1.72353 12.9428C1.97358 13.1928 2.31272 13.3333 2.66634 13.3333H13.333C13.6866 13.3333 14.0258 13.1928 14.2758 12.9428C14.5259 12.6928 14.6663 12.3536 14.6663 12V5.99999C14.6663 5.64637 14.5259 5.30723 14.2758 5.05718C14.0258 4.80713 13.6866 4.66666 13.333 4.66666H11.333L9.66634 2.66666Z",
    stroke: "#F8FAFC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667C9.10457 10.6667 10 9.77123 10 8.66666C10 7.56209 9.10457 6.66666 8 6.66666C6.89543 6.66666 6 7.56209 6 8.66666C6 9.77123 6.89543 10.6667 8 10.6667Z",
    stroke: "#F8FAFC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraButtonIcon);
export default __webpack_public_path__ + "static/media/camera-button-icon.100b2f94d18fb8d07d55a34b35d2c6ab.svg";
export { ForwardRef as ReactComponent };